"use client";

import React from "react";
import ChatButtons from "./ChatButtons";
import { useGlobalChat } from "../contexts/ChatContext";

const ChatInput: React.FC = () => {
  const { availableOptions, handleButtonClick, isTyping } = useGlobalChat();

  // Don't show options while typing
  if (isTyping) {
    return (
      <div
        className="border-t border-gray-200 p-4 flex items-center justify-center chat-typing-indicator"
        aria-live="polite"
        aria-label="Bot is typing"
      >
        <div className="flex space-x-2 items-center">
          <div
            className="w-2 h-2 bg-gray-400 rounded-full"
            style={{ animationDelay: "0ms" }}
          ></div>
          <div
            className="w-2 h-2 bg-gray-400 rounded-full"
            style={{ animationDelay: "150ms" }}
          ></div>
          <div
            className="w-2 h-2 bg-gray-400 rounded-full"
            style={{ animationDelay: "300ms" }}
          ></div>
        </div>
      </div>
    );
  }

  return (
    <ChatButtons options={availableOptions} onButtonClick={handleButtonClick} />
  );
};

export default ChatInput;
